import React, { useCallback, useState } from 'react'
import { ModelAction, PanelMessageIn } from './types'

import {
  checkDotNet, getHost, sendMessageDotNet,
} from './utilities'

export const useSendHbjson = () => {
  const host = getHost()
  const [state, setState] = useState({})

  const sendHbjson = useCallback((action: ModelAction, message: PanelMessageIn) => {
    if (!checkDotNet()) return

    const response = sendMessageDotNet({ action, ...message })

    setState((state) => ({
      ...state,
      response,
    }))

    return response
  }, [])

  return ({
    host,
    state,
    sendHbjson,
  })
}
